import { useEffect, useState } from 'react'
import RegisterForm from '../components/RegisterForm'
import { useTranslation } from 'react-i18next'
import { ScreenModeType } from '../pages/LoginRegisterPages'
import { Link } from 'react-router-dom'
import { FaHome } from 'react-icons/fa'

interface RegisterPageProps {
  onSwitchMode: (mode: ScreenModeType) => void
  initialStatus?: string
}

const RegisterPage: React.FC<RegisterPageProps> = ({
  onSwitchMode,
  initialStatus = '',
}) => {
  const { t } = useTranslation()
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true)
    }, 200)

    return () => clearTimeout(timer)
  }, [])

  return (
    <div
      className='flex justify-center items-center h-screen w-full px-0 sm:pr-2.5 text-anthracite'
      style={{
        backgroundImage:
          "url('/images/signinSignupBg/sexagogo-bg-register.jpg')",
      }}
    >
      <div
        className={`${
          isVisible ? 'opacity-100' : 'opacity-0'
        } transition-opacity duration-1000 ease-in-out flex w-full h-full`}
      >
        <div className='flex flex-col items-center relative justify-center w-1/2 bg-white'>
          <div className='absolute right-4 top-4 bg-redpink text-white rounded-lg'>
            <Link
              to='/'
              className='p-2 sm:p-3 flex items-center hover:bg-anthracite transition-all bg-redpink text-white rounded-lg'
            >
              <FaHome className='text-xl sm:text-2xl' />
            </Link>
          </div>
          <h3 className='text-center text-3xl font-medium p-0 m-0 w-full'>
            {t('create-an-account')}
          </h3>
          <p className='pt-0 mt-0 text-center pb-5 text-sm w-full'>
            {t('create-account-info')}{' '}
            <a href='www.sexagogo.be' className='text-redpink'>
              sexagogo.be
            </a>{' '}
            !
          </p>

          <RegisterForm
            onSwitchMode={onSwitchMode}
            initialStatus={initialStatus}
          />
        </div>
      </div>
    </div>
  )
}

export default RegisterPage
